$(window).on("load", function () {
  $(".header__mobile__hamburger").click(function () {
    $(this).toggleClass("active");
    $(".header__mobile__hamburger .stick").toggleClass(function () {
      return $(this).is(".open, .close") ? "open close" : "open";
    });
  });

  $(".header__desktop__hamburger").click(function () {
    $(this).toggleClass("active");
    $(".header__desktop__main").toggleClass("open");
    $(".header__desktop__main .stick").toggleClass(function () {
      return $(this).is(".open, .close") ? "open close" : "open";
    });
  });

  // full slider
  $(".slider--full .swiper-container").each(function () {
    if ($(this).find(".swiper-slide").length > 1) {
      var swiper = new Swiper(this, {
        direction: "horizontal",
        loop: true,
        pagination: {
          clickable: true,
          el: $(this).parent().find(".swiper-pagination")[0],
        },
        navigation: {
          nextEl: $(this).parent().find(".swiper-button-next")[0],
          prevEl: $(this).parent().find(".swiper-button-prev")[0],
        },
      });
    } else {
      $(this)
        .parent()
        .find(".swiper-button-next, .swiper-button-prev, .swiper-pagination")
        .hide();
    }
  });

  // pagination slider
  $(".slider--pagination .swiper-container").each(function () {
    if ($(this).find(".swiper-slide").length > 1) {
      var swiper = new Swiper(this, {
        direction: "horizontal",
        loop: true,
        pagination: {
          clickable: true,
          el: $(this).parent().find(".swiper-pagination")[0],
        },
      });
    } else {
      $(this)
        .parent()
        .find(".swiper-button-next, .swiper-button-prev, .swiper-pagination")
        .hide();
    }
  });

  // pagination slider custom
  $(".slider--pagination-custom .swiper-container").each(function () {
    var thisContainerCustomPagination = $(this)
      .parent()
      .find(".custom-pagination");
    var customPaginationArray = [];

    $(thisContainerCustomPagination)
      .find("span")
      .each(function () {
        if ($(this).data("title") != null || $(this).data("title") != "") {
          customPaginationArray.push($(this).data("title"));
        }
      });

    if ($(this).find(".swiper-slide").length > 1) {
      var swiperCustomPagination = new Swiper(this, {
        direction: "horizontal",
        loop: true,
        touchEventsTarget: "wrapper",
        pagination: {
          el: $(this).parent().find(".arrow-box ul")[0],
          clickable: true,
          bulletClass: "arrow-box__item",
          bulletActiveClass: "active",
          renderBullet: function (index, className) {
            return (
              '<li class="' +
              className +
              '">' +
              customPaginationArray[index] +
              "</li>"
            );
          },
        },
      });
    } else {
      $(this)
        .parent()
        .find(
          ".swiper-button-next, .swiper-button-prev, .swiper-pagination, .arrow-box"
        )
        .hide();
    }
  });

  // splitted slider
  $(".slider--splitted .swiper-container").each(function () {
    if ($(this).find(".swiper-slide").length > 1) {
      var swiper = new Swiper(this, {
        direction: "horizontal",
        loop: true,
        pagination: {
          clickable: true,
          el: $(this).parent().find(".swiper-pagination")[0],
        },
        navigation: {
          nextEl: $(this).parent().find(".swiper-button-next")[0],
          prevEl: $(this).parent().find(".swiper-button-prev")[0],
        },
      });
    } else {
      $(this)
        .parent()
        .find(".swiper-button-next, .swiper-button-prev, .swiper-pagination")
        .hide();
    }
  });

  // three col slider
  $(".slider--three-col .swiper-container").each(function () {
    var swiper = new Swiper(this, {
      direction: "horizontal",
      loop: true,
      slidesPerView: 3,
      spaceBetween: 50,
      pagination: {
        el: $(this).parent().find(".swiper-pagination")[0],
      },
      navigation: {
        nextEl: $(this).parent().find(".swiper-button-next")[0],
        prevEl: $(this).parent().find(".swiper-button-prev")[0],
      },
      breakpoints: {
        // when window width is >= 320px
        320: {
          slidesPerView: 1,
          spaceBetween: 0,
        },
        // when window width is >= 480px
        768: {
          slidesPerView: 2,
          spaceBetween: 30,
        },
        // when window width is >= 640px
        1180: {
          slidesPerView: 3,
          spaceBetween: 50,
        },
      },
    });
  });

  // inline popup
  $(".mfp-inline-popup").each(function () {
    $(this).magnificPopup({
      type: "inline",
      midClick: true,
      callbacks: {
        close: function () {
          $("video").each(function () {
            $(this).trigger("pause");
          });
          document.getElementsByTagName("video")[0].pause();
        },
      },
    });
  });
});

// thumbnail galerie
$(".thumbnail-galerie").each(function () {
  // the containers for all your galleries
  $(this).magnificPopup({
    delegate: "a", // the selector for gallery item
    type: "image",
    gallery: {
      enabled: true,
    },
  });
});

// banner scroll down arrow
$(".banner__bottom-icon").each(function () {
  $(this).click(function () {
    var parentHeight = $(this).closest(".banner").height();
    $("html, body").animate({ scrollTop: parentHeight }, 500);
  });
});

// Map switch
$(function () {
  setTimeout(function () {
    $(".sy_location--map--item2").hide();
    $(".sy_location--map--item3").hide();
  }, 2000);
});
$(".sy_location--header--address").each(function () {
  $(this).click(function () {
    $(".sy_location--header--address").removeClass("active");
    $(".sy_location--map--item1").hide();
    $(".sy_location--map--item2").hide();
    $(".sy_location--map--item3").hide();
    var currentMap = $(this).data("address");

    $(".sy_location--map--item" + currentMap).show();
    $(this).addClass("active");
  });
});

//tabs
$(document).ready(function () {
  $(".tabs").each(function () {
    $(this).tabs();
  });
});

// Aufklapp Texte
$(".sy_foldouttext--wrapper--opener").click(function () {
  $(this).hide();
  $(this).parent().find(".sy_foldouttext--wrapper--opentext").slideToggle();
});
$(".sy_foldouttext--wrapper--closer").click(function () {
  $(this)
    .parent()
    .slideToggle(function () {
      $(this).parent().parent().find(".sy_foldouttext--wrapper--opener").show();
    });
});


$(document).ready(function() {
  // scroll to anchor, with offset for navigation
  // only if we have anchor on the url
  if (window.location.hash) {
    // smooth scroll to the anchor id
    jQuery("html, body").animate(
      {
        scrollTop: jQuery(window.location.hash).offset().top - 100,
      },
      "slow"
    );
  }
})
